/**
 * Thank You Page - Shown to clients after assessment completion
 */

import { CheckCircle } from 'lucide-react';
import styles from './ThankYouPage.module.css';

export function ThankYouPage() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        {/* Success Icon */}
        <div className={styles.iconContainer}>
          <div className={styles.iconWrapper}>
            <CheckCircle className={styles.icon} />
          </div>
        </div>

        {/* Heading */}
        <h1 className={styles.heading}>
          ¡Gracias por completar el assessment!
        </h1>

        {/* Message */}
        <div className={styles.message}>
          <p className={styles.messageText}>
            Hemos recibido tu información exitosamente.
          </p>
          <p className={styles.messageSubtext}>
            Nuestro equipo de expertos en IA revisará tu assessment y se pondrá en contacto contigo 
            dentro de las próximas <span className={styles.highlight}>24-48 horas</span> con un análisis 
            detallado de oportunidades de automatización para tu empresa.
          </p>
        </div>

        {/* What's Next Section */}
        <div className={styles.whatsNext}>
          <h2 className={styles.whatsNextTitle}>
            ¿Qué sigue?
          </h2>
          <ul className={styles.whatsNextList}>
            <li className={styles.whatsNextItem}>
              <span className={styles.checkmark}>✓</span>
              <span>Analizaremos tus respuestas y procesos</span>
            </li>
            <li className={styles.whatsNextItem}>
              <span className={styles.checkmark}>✓</span>
              <span>Identificaremos oportunidades específicas de IA y automatización</span>
            </li>
            <li className={styles.whatsNextItem}>
              <span className={styles.checkmark}>✓</span>
              <span>Te contactaremos para discutir las recomendaciones</span>
            </li>
          </ul>
        </div>

       

        {/* Footer Note */}
        <p className={styles.footerNote}>
          Si tienes alguna pregunta, no dudes en contactarnos.
        </p>
      </div>
    </div>
  );
}

